import {
    ALL_CONSENTS,
    CONSENTS,
    ConsentKeys,
    UPDATED_CONSENT_EVENT_NAME,
    hasConsentFor,
} from "./consents-cookie-bot";

type PromiseValues = {
    resolve: () => void;
    reject: (reason?: unknown) => void;
};
const promiseResults: Partial<Record<ConsentKeys, PromiseValues>> = {};
const promises: Partial<Record<ConsentKeys, Promise<void>>> = {};

export function awaitConsent(consentCategory: ConsentKeys) {
    promises[consentCategory] =
        promises[consentCategory] ??
        new Promise((resolve, reject) => {
            promiseResults[consentCategory] = { resolve, reject };
            if (hasConsentFor(consentCategory)) {
                promiseResults[consentCategory].resolve();
            }
        });
    return promises[consentCategory];
}

export const hasConsentNecessary = () => hasConsentFor(CONSENTS.necessary);
export const hasConsentStatistic = () => hasConsentFor(CONSENTS.statistic);
export const hasConsentMarketing = () => hasConsentFor(CONSENTS.marketing);

export const awaitConsentNecessary = () => awaitConsent(CONSENTS.necessary);
export const awaitConsentStatistic = () => awaitConsent(CONSENTS.statistic);
export const awaitConsentMarketing = () => awaitConsent(CONSENTS.marketing);

export default function initConsents() {
    addEventListener(UPDATED_CONSENT_EVENT_NAME, () => {
        ALL_CONSENTS.forEach((consentType) => {
            if (!hasConsentFor(consentType)) {
                return;
            }

            if (promises[consentType]) {
                promiseResults[consentType]?.resolve();
            }
        });
    });
}
